import { render, staticRenderFns } from "./UserEditTabMedia.vue?vue&type=template&id=79346026&v-if=medias&"
import script from "./UserEditTabMedia.vue?vue&type=script&lang=js&"
export * from "./UserEditTabMedia.vue?vue&type=script&lang=js&"
import style0 from "./UserEditTabMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports